const getMembersStatusColors = (status) => {
  switch (status) {
    case 'invited':
      return '#4b5d6b'
    case 'active':
      return '#2d87d9'
    case 'finished':
      return '#217869'
    case 'deleted':
      return '#c2cfd8'
    case 'blocked':
      return '#d2465c'
    default:
      return ''
  }
}

export { getMembersStatusColors }
